<template>
  <div class="goodDetail">
    <div class="bg1">123</div>
    <div class="goodCont">
      <div class="tohome">
        当前位置：<span style="cursor: pointer" @click="toHome">首页</span>＞<span>商品详情</span>
      </div>
      <div class="goodInfo">
        <div class="leftInfo">
          <img :src="goodDetail.imgaddr" alt="" />
        </div>
        <div class="rightInfo">
          <div class="goodName">
            {{ goodDetail.title }}
          </div>
          <div class="goodSpec">生产厂家：{{ goodDetail.comm }}</div>
          <div class="goodSpec">规格：{{ goodDetail.spec }}</div>
          <div class="goodSpec">
            {{ goodDetail.wh }}
          </div>
          <div class="goodInst">
            {{ goodDetail.instructions }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      goodList: [
        {
          id: 1,
          imgaddr: require("@imgs/1.png"),
          title: "感冒灵颗粒(999)",
          comm: "华润三九医药股份有限公司",
          spec: "10g*9袋",
          wh: "【批准文号】国药准字Z44021940",
        },
        {
          id: 2,
          imgaddr: require("@imgs/2.png"),
          title: "藿香正气水",
          comm: "四川天府康达药业集团府庆制药有限公司",
          spec: "10ml*10支",
          wh: "【批准文号】国药准字Z51022378",
        },
        {
          id: 3,
          imgaddr: require("@imgs/3.png"),
          title: "小柴胡颗粒(有糖)",
          comm: "广州白云山光华制药股份有限公司",
          spec: "10g*10袋",
          wh: "【批准文号】国药准字Z44020211",
        },
      ],
      id: "",
      goodDetail: {},
    };
  },
  mounted() {
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
      var goodList = this.goodList.filter((v) => {
        return v.id == this.id;
      });
      this.goodDetail = goodList[0];
    }
    console.log(this.goodDetail);
  },
  methods: {
    toHome() {
      this.$router.push("/");
    },
  },
};
</script>

<style lang="scss" scoped>
.goodDetail {
  .bg1 {
    width: 195px;
    height: 50px;
  }

  .goodCont {
    width: 1200px;
    margin: 0 auto;
    margin-top: 30px;
    min-height: 449px;

    .tohome {
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 300;
      text-align: left;
    }

    .goodInfo {
      display: flex;
      margin-top: 40px;

      .leftInfo {
        width: 200px;
        height: 200px;
        margin-right: 20px;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .rightInfo {
        text-align: left;

        .goodName {
          font-size: 24px;
          font-weight: bold;
        }

        .goodSpec {
          font-size: 14px;
          color: #4d4d4d;
          margin-top: 10px;
        }

        .goodInst {
          font-size: 18px;
          color: #4d4d4d;
          margin-top: 20px;
        }
      }
    }
  }
}</style>